import { State } from "../../../vendor_core/core/src/states/State";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import { MoneyField } from "../../../vendor_core/core/src/views/MoneyField";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIModes, UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import BBReelGroup from "../view/BBReelGroup";
import { TweenMax } from 'gsap';
import Locale from "../../../vendor_core/core/src/utils/Locale";
import BBAnimationsHelper from "../utils/BBAnimationsHelper";
import KeyboardManager, { Key } from "../../../vendor_core/core/src/utils/KeyboardManager";
import BBUtils from '../utils/utils';
import { UIUpdateEvent } from '../../../vendor_core/core/src/ui/UIUpdateEvents';
import RelaxPOSTMessageController from '../../../vendor_core/server/RelaxPOSTMessageController';

export default class BBEnterFreeSpinsState extends State {
    protected scene: SceneView;
    protected freespinCount: MoneyField;
    public enter() {
        super.enter();
        // let layer = ViewManager.getLayer(DefaultLayers.Paylines).getCurrentScene()
        // TweenMax.delayedCall(1, () => {
        //     if (layer.getSubView("wildEffect")) {
        //         layer.removeSubView("wildEffect")
        //     }
        // })
        CommandManager.execute(Commands.UPDATE_WIN);

        TweenMax.delayedCall(1, () => {
            BBAnimationsHelper.playEnterFreeSpinWildAnim(3);
        });
        TweenMax.delayedCall(2.5, () => {
            // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").enableMask();
            SoundController.playSound('tornado');
            SpinModel.enterFreespins();
            SpinModel.freespinWinnings = SpinModel.currentWin;


            BBUtils.repositionLogo()

            BBAnimationsHelper.playTornadoAnimations(() => {
                ViewManager.getLayer("Tornado").clear();
                let backgroundLayer = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
                backgroundLayer.spineAnimations.get("bg").play("sunset", true);
                TweenMax.delayedCall(0.4, () => {
                    RelaxPOSTMessageController.featureStarted();
                    this.showPopup();
                })
            })
        });
    }

    public showPopup() {
        // let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
        //     .getCurrentScene()
        //     .getSubView("ReelGroup") as BBReelGroup;
        // reelGroup.hideLinesAndInfo(true);

        this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
            "freespinswin"
        );

        const anim = this.scene.spineAnimations.get("popup_win");
        anim.playChainingStates("big_win");
        // this.scene.sceneSprites.forEach(sp => sp.visible = false)
        let numOfWinSpins = (SpinModel.freespinsWon).toString();

        this.scene.sceneTextFields.get("value").text = numOfWinSpins;

        UIController.updateFields(UIUpdateEvent.FreeSpins, numOfWinSpins)
        UIController.setMode(UIModes.FREE_SPINS);
        UIController.setState(UIStates.FREE_SPINS);

        SoundController.playMusic(SoundVars.MUSIC_BONUS);
        // SoundController.playSound('freespins_transition');

        this.scene.once(PointerEvents.DOWN, () => {
            SoundController.playSound('freespins_transition');
            anim.playAsync("outro_big_win").then(() => {


                // SpinModel.enterFreespins();
                // SpinModel.freespinWinnings = SpinModel.currentWin;

                // UIController.setMode(UIModes.FREE_SPINS);
                // UIController.setState(UIStates.FREE_SPINS);
                // BBUtils.repositionLogo()

                ViewManager.getLayer(DefaultLayers.Popups).clear();
                this.scene.destroy();

                this.exit();
            });
        });

        KeyboardManager.onKey("pressed", Key.SPACE, () => this.scene.emit(PointerEvents.DOWN), this);

        this.scene.interactive = true;
    }

    public exit() {
        super.exit()
        // TweenMax.delayedCall(0.5, () => {
        //     // UIController.setMode(UIModes.FREE_SPINS);
        //     // UIController.setState(UIStates.FREE_SPINS);
        // })
    }
}
